import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgMiscAgent = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M16.707 16.707 15.414 18H8.307l-.301-.38-.79-1 1.568-1.24.49.62h5.312l.707-.707 1.414 1.414ZM9.5 11a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM14.5 11a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
    />
    <path
      fill="#88827E"
      fillRule="evenodd"
      d="M14 5h-1v2h7v4h2v7h-2v4H4v-4H2v-7h2V7h7V5h-1V2h4v3ZM6 20h12V9H6v11Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMiscAgent;
